"use client";
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { XCircle } from "lucide-react";
export function StatusModal({ isOpen, onClose, serviceName, status, details, url, missingTags = [], foundTags = [], keyword, context, sitemapUrl, }) {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        }
        else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isOpen]);
    if (!isOpen)
        return null;
    const modal = (React.createElement("div", { className: "fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-25", onClick: (e) => {
            if (e.target === e.currentTarget)
                onClose();
        } },
        React.createElement("div", { className: "flex min-h-full items-center justify-center p-4" },
            React.createElement("div", { className: "w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all", onClick: (e) => e.stopPropagation() },
                React.createElement("div", { className: "flex justify-between items-center mb-4" },
                    React.createElement("h3", { className: "text-lg font-medium leading-6 text-gray-900" },
                        serviceName,
                        " Status"),
                    React.createElement("button", { onClick: onClose, className: "text-gray-400 hover:text-gray-500 transition-colors" },
                        React.createElement(XCircle, { className: "h-6 w-6" }))),
                React.createElement("div", { className: "mt-4" },
                    React.createElement("p", { className: "text-sm text-gray-500 mb-2" },
                        React.createElement("strong", null, "Status:"),
                        " ",
                        React.createElement("span", { className: status === "available"
                                ? "text-green-600"
                                : status === "outage"
                                    ? "text-red-600"
                                    : status === "not_implemented"
                                        ? "text-yellow-600"
                                        : "text-blue-600" }, status
                            .split("_")
                            .map((word) => word.charAt(0).toUpperCase() +
                            word.slice(1))
                            .join(" "))),
                    React.createElement("p", { className: "text-sm text-gray-500 mb-2" },
                        React.createElement("strong", null, "URL:"),
                        " ",
                        url),
                    React.createElement("p", { className: "text-sm text-gray-500 mb-4" },
                        React.createElement("strong", null, "Details:"),
                        " ",
                        details),
                    keyword && (React.createElement("div", { className: "mb-4" },
                        React.createElement("h4", { className: "text-sm font-medium text-gray-900 mb-2" }, "Keyword Check:"),
                        React.createElement("p", { className: "text-sm text-gray-600 mb-2" },
                            React.createElement("strong", null, "Searching for:"),
                            " \"",
                            keyword,
                            "\""),
                        context && (React.createElement("div", { className: "bg-gray-50 p-3 rounded-md" },
                            React.createElement("p", { className: "text-sm text-gray-600 italic" },
                                "Context: ",
                                context))))),
                    sitemapUrl && (React.createElement("div", { className: "mb-4" },
                        React.createElement("h4", { className: "text-sm font-medium text-gray-900 mb-2" }, "Sitemap URL:"),
                        React.createElement("p", { className: "text-sm text-gray-600 mb-2" }, sitemapUrl))),
                    missingTags.length > 0 && (React.createElement("div", { className: "mb-4" },
                        React.createElement("h4", { className: "text-sm font-medium text-gray-900 mb-2" }, "Missing Tags:"),
                        React.createElement("ul", { className: "list-disc list-inside text-sm text-red-600" }, missingTags.map((tag) => (React.createElement("li", { key: tag }, tag)))))),
                    foundTags.length > 0 && (React.createElement("div", null,
                        React.createElement("h4", { className: "text-sm font-medium text-gray-900 mb-2" }, "Found Tags:"),
                        React.createElement("div", { className: "max-h-40 overflow-y-auto" },
                            React.createElement("table", { className: "min-w-full text-sm" },
                                React.createElement("thead", null,
                                    React.createElement("tr", null,
                                        React.createElement("th", { className: "text-left font-medium text-gray-900" }, "Name"),
                                        React.createElement("th", { className: "text-left font-medium text-gray-900" }, "Content"))),
                                React.createElement("tbody", null, foundTags.map((tag, index) => (React.createElement("tr", { key: index, className: "border-t" },
                                    React.createElement("td", { className: "py-2 text-gray-600" }, tag.name),
                                    React.createElement("td", { className: "py-2 text-gray-600 truncate max-w-[200px]" }, tag.content))))))))))))));
    return createPortal(modal, document.body);
}
